<template>
  <div>
    <label
      v-if="label"
      class="form-label text-sm"
      :for="id">{{ label }}:</label>
    <textarea
      :id="id"
      ref="input"
      :maxlength="maxLength"
      v-bind="$attrs"
      class="form-textarea"
      :class="{ error: error }"
      :value="value"
      @input="$emit('input', $event.target.value)" />
    <div v-if="error" class="form-error">
      {{ error }}
    </div>
  </div>
</template>

<script>
export default {
  inheritAttrs: false,
  props: {
    id: {
      type: String,
      default () {
        return `textarea-input-${this._uid}`
      },
    },
    value: String,
    label: String,
    error: String,
    maxLength: Number,
  },
  methods: {
    focus () {
      this.$refs.input.focus()
    },
    select () {
      this.$refs.input.select()
    },
  },
}
</script>
